import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Toast from "cogo-toast";
import {Link} from "react-router-dom";
import {MdBarcodeReader} from "react-icons/md";
import {GiTurnstile} from "react-icons/gi";
import {FiPlus} from "react-icons/fi";
import {TurnstileButton} from "../components/Button";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {apiGetTurnstile} from "./Actions";
import TurnstileTable from "./TurnstileTable";
import ConfigQrModal from "./ConfigQrModal";
import {SET_FILTER_RESET} from "../../../reducers/filterEntrance";
import PageHeader from "../components/PageHeader";
import CustomTabs from "../components/CustomTabs";
import {SET_FILTER_TURNSTILE} from "../../../reducers/filterTurnstile";
import {useIsMobile} from "../components/Helper";

// ─── Main ─────────────────────────────────────────────────────────────────────

const Turnstile = () => {
    const [data, setData] = useState(null);
    const [finalData, setFinalData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalConfig, setModalConfig] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const user = useSelector(s => s.user);
    const filters = useSelector(s => s.filterTurnstile);
    const dispatch = useDispatch();
    const canEdit = !!user?.user?.rights?.enigooTurniketsEdit;
    const isMobile = useIsMobile();

    useEffect(() => {
        if (!filters.autoRefresh || !user.activeAreal) { setCountdown(30); return; }
        setCountdown(30);
        const refresh = setInterval(() => { getData(user.activeAreal.id); setCountdown(30); }, 30000);
        const tick = setInterval(() => setCountdown(c => c - 1), 1000);
        return () => { clearInterval(refresh); clearInterval(tick); };
    }, [filters.autoRefresh, user.activeAreal]);

    useEffect(() => {
        user.activeAreal && getData(user.activeAreal.id);
    }, [user.activeAreal]);

    useEffect(() => {
        const turnstiles = [];
        const readers = [];
        if (data?.turnstile) {
            data.turnstile.forEach(item => {
                if (item.turnstileType === 6 || item.turnstileType === 7) {
                    readers.push(item);
                } else {
                    turnstiles.push(item);
                }
            });
        }
        setFinalData({turnstiles, readers});
    }, [data]);

    const getData = (arealId) => {
        setLoading(true);
        apiGetTurnstile(arealId, null, (d) => {
            setData(d);
            setLoading(false);
        }, () => {
            Toast.error("Při načítání turniketů nastala chyba.");
            setData(null);
            setLoading(false);
        });
    };

    const buildTabs = () => {
        const tabs = [];
        if (finalData?.turnstiles?.length > 0) {
            tabs.push({
                label: "Turnikety",
                icon: <GiTurnstile size={15}/>,
                count: finalData.turnstiles.length,
                content: <TurnstileTable data={finalData.turnstiles} onRefresh={() => getData(user.activeAreal.id)}/>
            });
        }
        if (finalData?.readers?.length > 0) {
            tabs.push({
                label: "Čtečky",
                icon: <MdBarcodeReader size={15}/>,
                count: finalData.readers.length,
                content: <TurnstileTable data={finalData.readers} onRefresh={() => getData(user.activeAreal.id)}/>
            });
        }
        return tabs;
    };

    return (
        <>
            <ConfigQrModal visible={modalConfig} close={() => setModalConfig(false)}/>

            {user.activeAreal && (
                <>
                    <PageHeader crumbs={[{label: "Turnikety"}]}>
                        {/* auto-refresh toggle */}
                        <button
                            onClick={() => dispatch({type: SET_FILTER_TURNSTILE, payload: {autoRefresh: !filters.autoRefresh}})}
                            style={{display: "flex", alignItems: "center", gap: "7px", background: "none", border: "none", cursor: "pointer", padding: 0}}
                            title="Automatický refresh každých 30s"
                        >
                            <span style={{
                                display: "inline-block", width: "34px", height: "18px", borderRadius: "999px",
                                background: filters.autoRefresh ? "#2563eb" : "#cbd5e1",
                                position: "relative", transition: "background 0.2s", flexShrink: 0,
                            }}>
                                <span style={{
                                    position: "absolute", top: "2px",
                                    left: filters.autoRefresh ? "18px" : "2px",
                                    width: "14px", height: "14px", borderRadius: "50%",
                                    background: "#fff", transition: "left 0.2s",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                }}/>
                            </span>
                            <span style={{fontSize: "var(--enigoo-fs-xs)", fontWeight: 600, color: filters.autoRefresh ? "#2563eb" : "#94a3b8", whiteSpace: "nowrap"}}>
                                Auto-refresh
                                {filters.autoRefresh && (
                                    <span style={{marginLeft: "4px", fontWeight: 400, color: "#94a3b8"}}>({countdown}s)</span>
                                )}
                            </span>
                        </button>
                        {canEdit && (
                            <>
                                <TurnstileButton onClick={() => setModalConfig(true)} text="QR PRO TELPO" color="outline"/>
                                <TurnstileButton link="/turnstile/add" text="PŘIDAT TURNIKET" icon={<FiPlus size={12}/>}/>
                            </>
                        )}
                    </PageHeader>

                    {/* content */}
                    {loading
                        ? <DefaultLoader text={"Načítám turnikety..."}/>
                        : finalData && <CustomTabs tabs={buildTabs()}/>
                    }
                </>
            )}
        </>
    );
};

export default Turnstile;
